// @flow

import React, { Component } from 'react'

export default class ScrollControlView extends Component<*> {
  componentDidMount() {
    if (this.contentsElement) {
      this.contentsElement.addEventListener('touchmove', this.handleScroll, {
        passive: false,
      })
      this.contentsElement.addEventListener('wheel', this.handleScroll, {
        passive: false,
      })
    }
  }

  componentWillUnmount() {
    if (this.contentsElement) {
      this.contentsElement.removeEventListener('touchmove', this.handleScroll)
      this.contentsElement.removeEventListener('wheel', this.handleScroll)
    }
  }

  handleScroll: Function
  contentsElement: ?HTMLDivElement

  handleScroll = (e: Event) => {
    if (this.props.isLock) {
      e.preventDefault()
    }
  }

  render() {
    return (
      <div
        ref={el => {
          this.contentsElement = el
        }}
      >
        {this.props.children}
      </div>
    )
  }
}
